export default __webpack_public_path__ + "static/media/Nissin.d6674783.svg";